import {
    CORE_LOAD_MANAGE_SYSTEMS_REQUEST,
    CORE_LOAD_MANAGE_SYSTEMS_SUCCESS,
    CORE_LOAD_MANAGE_SYSTEMS_FAILURE,

    CORE_LOAD_MANAGE_SYSTEM_REQUEST,
    CORE_LOAD_MANAGE_SYSTEM_SUCCESS,
    CORE_LOAD_MANAGE_SYSTEM_FAILURE,

} from '../../manageTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    manageSystems: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MANAGE_SYSTEMS_REQUEST:
                return state
            case CORE_LOAD_MANAGE_SYSTEMS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MANAGE_SYSTEMS_FAILURE:
                return []
            default:
                return state
        }
    },
    manageSystem: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MANAGE_SYSTEM_REQUEST:
                return state
            case CORE_LOAD_MANAGE_SYSTEM_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MANAGE_SYSTEM_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/manage/system.js